import React from 'react';
import { AppBar, Toolbar, IconButton, Box, Breadcrumbs, Typography, Tooltip, Button } from '@mui/material';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { useTheme } from '../../contexts/ThemeContext';
import SproutIcon from '../Common/SproutIcon';
import { Menu1, Sun2, MoonStar1, BoxDownload, ChevronRight } from '../Common/icons';
import { findBreadcrumbs } from '../../config/navigation';
import { DATAPLATFORM_GITLAB_PACKAGES_URL } from '../../utils/packageRegistry';

const Header = ({ onMenuClick }) => {
  const { mode, toggleTheme } = useTheme();
  const location = useLocation();
  const crumbs = findBreadcrumbs(location.pathname);

  return (
    <AppBar position="sticky" sx={{ top: 0, zIndex: (theme) => theme.zIndex.appBar }}>
      <Toolbar sx={{ minHeight: { xs: 56, sm: 64 }, gap: 1, px: { xs: 2, md: 4 } }}>
        <IconButton
          aria-label="open drawer"
          edge="start"
          onClick={onMenuClick}
          sx={{ display: { md: 'none' }, color: 'text.primary' }}
        >
          <SproutIcon icon={Menu1} size={22} />
        </IconButton>

        <Box sx={{ flexGrow: 1, minWidth: 0 }}>
          {crumbs.length > 0 ? (
            <Breadcrumbs
              aria-label="breadcrumb"
              separator={<SproutIcon icon={ChevronRight} size={12} />}
              sx={{ '& .MuiBreadcrumbs-ol': { flexWrap: 'nowrap' }, color: 'text.secondary' }}
            >
              {crumbs.map((crumb, index) => {
                const isLast = index === crumbs.length - 1;
                return (
                  <Typography
                    key={crumb.title}
                    noWrap
                    sx={{
                      fontSize: '0.875rem',
                      fontWeight: isLast ? 700 : 500,
                      color: isLast ? 'text.primary' : 'text.secondary',
                      display: { xs: isLast ? 'block' : 'none', sm: 'block' },
                    }}
                  >
                    {crumb.title}
                  </Typography>
                );
              })}
            </Breadcrumbs>
          ) : (
            <Typography noWrap sx={{ fontSize: '0.875rem', fontWeight: 700 }}>
              Overview
            </Typography>
          )}
        </Box>

        <Button
          component="a"
          href={DATAPLATFORM_GITLAB_PACKAGES_URL}
          target="_blank"
          rel="noopener noreferrer"
          variant="outlined"
          size="small"
          startIcon={<SproutIcon icon={BoxDownload} size={16} />}
          sx={{ display: { xs: 'none', sm: 'inline-flex' }, borderColor: 'divider', color: 'text.primary' }}
        >
          Package registry
        </Button>

        <Tooltip title={mode === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}>
          <IconButton
            onClick={toggleTheme}
            aria-label="toggle theme"
            sx={{ color: 'text.primary', border: 1, borderColor: 'divider', p: 0.75 }}
          >
            <SproutIcon icon={mode === 'dark' ? Sun2 : MoonStar1} size={18} />
          </IconButton>
        </Tooltip>
      </Toolbar>
    </AppBar>
  );
};

Header.propTypes = {
  onMenuClick: PropTypes.func.isRequired,
};

export default Header;
